export default "__VITE_ASSET__ozsWqDle__"